// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1e4xm3z0 {
  display: grid;
  appearance: none;
  background-color: white;
  margin: 0;
  font: inherit;
  color: currentColor;
  border: 2px solid;
  border-color: var(--_18w76bw35);
  border-radius: 50%;
  place-content: center;
  transition: 100ms transform ease-in-out;
}
._1e4xm3z0:before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transform: scale(0);
  transition: 100ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--_18w76bw2w);
}
._1e4xm3z0:hover:not(:checked), ._1e4xm3z0:hover:not(.checked) {
  border-color: var(--_18w76bw35);
}
._1e4xm3z0:checked, ._1e4xm3z0.checked {
  border-color: var(--_18w76bw2w);
}
._1e4xm3z0:checked:before, ._1e4xm3z0.checked:before {
  transform: scale(1);
}
._1e4xm3z1 {
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;EACrB,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["._1e4xm3z0 {\n  display: grid;\n  appearance: none;\n  background-color: white;\n  margin: 0;\n  font: inherit;\n  color: currentColor;\n  border: 2px solid;\n  border-color: var(--_18w76bw35);\n  border-radius: 50%;\n  place-content: center;\n  transition: 100ms transform ease-in-out;\n}\n._1e4xm3z0:before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  transform: scale(0);\n  transition: 100ms transform ease-in-out;\n  box-shadow: inset 1em 1em var(--_18w76bw2w);\n}\n._1e4xm3z0:hover:not(:checked), ._1e4xm3z0:hover:not(.checked) {\n  border-color: var(--_18w76bw35);\n}\n._1e4xm3z0:checked, ._1e4xm3z0.checked {\n  border-color: var(--_18w76bw2w);\n}\n._1e4xm3z0:checked:before, ._1e4xm3z0.checked:before {\n  transform: scale(1);\n}\n._1e4xm3z1 {\n  width: 16px;\n  height: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
